/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type HorizontalNavViewEntrypointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const horizontalNavViewEntrypoint: EntryPoint<HorizontalNavViewEntrypointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<HorizontalNavViewEntrypointComponent>(
			/* webpackChunkName: "async-horizontal-nav-view-entrypoint" */ './ui/index.tsx',
			{
				includeInShellOnlySsrBundle: true,
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
